import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VBottomSheet, {
    attrs: {
      scrollable: "",
      width: "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          staticClass: "dfwa-btn",
          class: _vm.btnClassSupp,
          attrs: {
            rounded: true
          }
        }, "v-btn", attrs, false), on), [_c(VIcon, {
          attrs: {
            left: "",
            small: "",
            dark: ""
          }
        }, [_vm._v("far fa-comment")]), _c("span", [_vm._v("Comments (" + _vm._s(_vm.comments.length) + ")")])], 1)];
      }
    }]),
    model: {
      value: _vm.commentContainer,
      callback: function callback($$v) {
        _vm.commentContainer = $$v;
      },
      expression: "commentContainer"
    }
  }, [_c(VSheet, {
    staticClass: "v-sheet"
  }, [_c(VBtn, {
    staticClass: "close-action",
    attrs: {
      color: "primary",
      fab: "",
      small: ""
    },
    on: {
      click: function click($event) {
        _vm.commentContainer = !_vm.commentContainer;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      color: "black"
    }
  }, [_vm._v("fa fa-times")])], 1), _c("div", {
    staticClass: "comment-add"
  }, [_c(VTextarea, {
    staticClass: "ma-2 comment-area",
    attrs: {
      "no-resize": "",
      rows: "3",
      name: "Your comment",
      label: "Leave a comment here"
    },
    model: {
      value: _vm.comment,
      callback: function callback($$v) {
        _vm.comment = $$v;
      },
      expression: "comment"
    }
  }), _vm.errorLabels.comment.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.comment) + " ")]) : _vm._e(), _vm.idComment == null || _vm.idComment == 0 ? _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.saveComment();
      }
    }
  }, [_c("span", [_vm._v("Save comment")])])], 1) : _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancelEditComment();
      }
    }
  }, [_c("span", [_vm._v("Cancel")])]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.saveComment();
      }
    }
  }, [_c("span", [_vm._v("Update Comment")])])], 1)], 1), _c("div", {
    staticClass: "comments-list"
  }, [_vm.comments.length == 0 ? _c("div", [_vm._v("No comments available")]) : _vm._e(), _vm._l(_vm.comments, function (comment) {
    return _c("div", {
      key: comment.id_comment,
      staticClass: "one-comment"
    }, [_c("div", {
      staticClass: "container-user-actions"
    }, [_c("div", {
      staticClass: "username"
    }, [_vm._v("By " + _vm._s(_vm.getFullNameUser(comment.user)))]), comment.user.id_user == _vm.currentIdUser ? _c("div", {
      staticClass: "comment-actions"
    }, [_c(VIcon, {
      attrs: {
        small: ""
      },
      on: {
        click: function click($event) {
          return _vm.prepareEditComment(comment);
        }
      }
    }, [_vm._v("fa-pen")]), _c(VIcon, {
      attrs: {
        small: ""
      },
      on: {
        click: function click($event) {
          return _vm.deleteComment(comment.id_comment);
        }
      }
    }, [_vm._v("fa-trash-alt")])], 1) : _vm._e()]), _c("div", {
      staticStyle: {
        clear: "both"
      }
    }), _c("div", {
      staticClass: "comment"
    }, [_vm._v(" " + _vm._s(comment.comment) + " ")]), _c("div", {
      staticClass: "date"
    }, [_vm._v(" " + _vm._s(_vm._f("formatDateTime")(comment.date_insert)) + " ")])]);
  })], 2)], 1), _c("confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };